import React from 'react';
import { useSelector } from 'react-redux';
import { selectHasRolledYet, selectIsMyTurn } from '../../redux/gameSlice';
import DiceLines from './DiceLines';
import { Trans } from '@lingui/macro';

export default function DiceArea(props) {
  const hasRolledDice = useSelector(selectHasRolledYet);
  const isMyTurn = useSelector(selectIsMyTurn);

  if (hasRolledDice === false) {
    if (isMyTurn) {
      return <p><Trans>It's your turn to roll the dice.<br />Good luck!</Trans></p>;
    }

    return <p><Trans>Waiting for a dice roll...</Trans></p>;
  }

  return <DiceLines diceHasEffect={props.diceHasEffect} />;
}
